module.exports = __webpack_public_path__ + "static/media/courage.1b2bb193.png";